module.exports = __webpack_public_path__ + "static/media/optima-seguros-bumper_selected.d755f4fb.svg";